import { createFileRoute } from "@tanstack/react-router";

import { SetupConsole } from "@/features/wonda/components/SetupConsole";
import { CliNav } from "@/landing/components/CliNav";
import { MinimalFooter } from "@/landing/components/MinimalFooter";

export const Route = createFileRoute("/_authenticated/(wonda)/_wonda/setup")({
  component: SetupPage,
});

function SetupPage() {
  return (
    <div className="flex min-h-[100dvh] flex-col">
      <CliNav />
      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col px-5 py-8 md:px-8">
        <SetupConsole />
      </main>
      <MinimalFooter />
    </div>
  );
}
